import React, { useState } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  Paper,
} from "@mui/material";
import httpRequest from "../utils/httpRequest";

const Upload = () => {
  const [customerFileName, setCustomerFileName] = useState("");
  const [ledgerFileName, setLedgerFileName] = useState("");
  const [loading, setLoading] = useState({ customer: false, ledger: false });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const validateFileName = (name) => {
    return name.match(/\.(xlsx|xlsm)$/i);
  };

  const handleUpload = async (type) => {
    const fileName = type === "customer" ? customerFileName : ledgerFileName;
    if (!fileName && type==="customer") {
      setSnackbar({ open: true, message: "Please enter a file name", severity: "warning" });
      return;
    }
    if (!validateFileName(fileName) && type === "customer") {
      setSnackbar({ open: true, message: "Please select a valid .xlsx or .xlsm file", severity: "error" });
      return;
    }

    try {
      setLoading((prev) => ({ ...prev, [type]: true }));
      const endpoint = type === "customer" ? "upload/customer-data" : "upload/customer-ledger-data";
      await httpRequest(endpoint, "POST", { filePath: fileName });
      setSnackbar({ 
        open: true, 
        message: `${type === "customer" ? "Customer Data" : "Customer Ledger"} imported successfully!`, 
        severity: "success" 
      });
      if (type === "customer") setCustomerFileName("");
      else setLedgerFileName("");
    } catch (err) {
      const errorMessage = err?.response?.data?.error || "Upload failed";
      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    } finally {
      setLoading((prev) => ({ ...prev, [type]: false }));
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, mx: "auto" }}>
      <Typography variant="h4" sx={{mb: 2}}>
        Data Upload Portal
      </Typography>
      <Grid container spacing={3}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "medium" }}>
              Customer Data
            </Typography>
            <TextField
              fullWidth
              label="Customer Data File (.xlsx / .xlsm)"
              variant="outlined"
              value={customerFileName}
              onChange={(e) => setCustomerFileName(e.target.value)}
              helperText="Please enter the path to a valid .xlsx or .xlsm file"
              sx={{ mb: 3 }}
              error={customerFileName && !validateFileName(customerFileName)}
            />
            <Button
              fullWidth
              variant="contained"
              onClick={() => handleUpload("customer")}
              disabled={loading.customer}
              sx={{
                py: 1.5,
                borderRadius: 1,
                textTransform: "none",
                fontSize: "1rem",
                position: "relative",
              }}
            >
              {loading.customer ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Upload Customer Data"
              )}
            </Button>
          </Paper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "medium" }}>
              Import Ledger Data
            </Typography>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {setLedgerFileName("myfile.xlsx"); handleUpload("ledger")}}
              disabled={loading.customer}
              sx={{
                py: 1.5,
                borderRadius: 1,
                textTransform: "none",
                fontSize: "1rem",
                position: "relative",
              }}
            >
              {loading.customer ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Import Ledger till 2024-25"
              )}
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%", boxShadow: 2 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Upload;